<template>
    <div>
        <v-row class="px-2 pt-2">
            <!-- Merchants -->
            <v-col md="4" class="py-0">
                <v-autocomplete
                    v-model="merchant"
                    label="Select a merchant"
                    :items="merchants"
                    item-value="uuid"
                    item-text="name"
                    dense
                    return-object
                    clearable
                    @change="getReport(); loading = true;"
                    @click:clear="clearMerchant()"
                ></v-autocomplete>
            </v-col>

            <!-- From Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="fromDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="fromDate"
                        label="From Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="fromDate"
                        @input="fromDateModal = false"
                        @click:date="handleDateFilters"
                        :max="maxdate"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <!-- To Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="toDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="toDate"
                        label="To Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="toDate"
                        @input="toDateModal = false"
                        @click:date="handleDateFilters"
                        :max="maxdate"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <v-col align="end" class="py-2">
                <v-btn
                    :disabled="true"
                    small
                    dark
                    color="primary"
                    class="mb-3"
                    @click="download"
                    ><v-icon>mdi-arrow-down-bold</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-row class="px-4">
            <v-col md="12" class="pa-2">
                <v-data-table
                    v-if="report"
                    :headers="headers"
                    :items="report"
                    :items-per-page="10"
                    class="elevation-0"
                >
                    <template v-slot:item.totalDebit="{ item }">
                        {{ new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(item.totalDebit) }}<br>
                    </template>

                    <template v-slot:item.totalCredit="{ item }">
                        {{ new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(item.totalCredit) }}<br>
                    </template>

                    <template v-slot:item.totalTransactions="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.totalTransactions) }}
                    </template>

                    <template v-slot:item.DB="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.DB) }}
                    </template>

                    <template v-slot:item.DS="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.DS) }}
                    </template>
                    
                    <template v-slot:item.PA="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.PA) }}
                    </template>

                    <template v-slot:item.RB="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.RB) }}
                    </template>
                    
                    <template v-slot:item.RF="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.RF) }}
                    </template>

                    <template v-slot:item.SD="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.SD) }}
                    </template>

                    <template v-slot:item.ThreeD="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.ThreeD) }}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

export default {
    data() {
        return {
            merchants: null,
            fromDateModal: null,
            toDateModal: null,
            fromDate: moment().startOf('month').format('YYYY-MM-DD'),
            toDate: moment().subtract('1', 'day').format('YYYY-MM-DD'),
            maxdate: moment().subtract('1', 'day').format('YYYY-MM-DD'),
            merchant: {},
            loading: true,
            report: null,
            headers: [{ text: 'Division', value: 'divisionName', sortable: true },
                      { text: 'Merchant', value: 'merchantName', sortable: true },
                      { text: 'Total Debit', value: 'totalDebit', sortable: true, align: "center",  width: 120 },
                      { text: 'Total Credit', value: 'totalCredit', sortable: true, align: "center", width: 120 },
                      { text: 'Total Transactions', value: 'totalTransactions', sortable: true, align: "center",  width: 180 },
                      { text: 'CP', value: 'CP', sortable: false, align: 'center' },
                      { text: 'DB', value: 'DB', sortable: false, align: 'center' },
                      { text: 'DR', value: 'DR', sortable: false, align: 'center' },
                      { text: 'DS', value: 'DS', sortable: false, align: 'center' },
                      { text: 'PA', value: 'PA', sortable: false, align: 'center' },
                      { text: 'RB', value: 'RB', sortable: false, align: 'center' },
                      { text: 'RF', value: 'RF', sortable: false, align: 'center' },
                      { text: 'RG', value: 'RG', sortable: false, align: 'center' },
                      { text: 'RR', value: 'RR', sortable: false, align: 'center' },
                      { text: 'RS', value: 'RS', sortable: false, align: 'center' },
                      { text: 'RV', value: 'RV', sortable: false, align: 'center' },
                      { text: 'SD', value: 'SD', sortable: false, align: 'center' },
                      { text: '3D', value: 'ThreeD', sortable: false, align: 'center' }]
        }
    },
    beforeMount() {
        this.getMerchants();
    },
    computed: {
        emptyMerchant() {
            if(Object.keys(this.merchant).length === 0 && this.merchant.constructor === Object) {
                console.log('t');
                return true;
            }
            else {
                console.log('f');
                return false;
            }
        }
    },
    methods: {
        getMerchants() {
            if(this.$store.getters.role <= 3) {
                axios({
                method: 'get',
                url: `get-merchants-live`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                    this.getReport();
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else {
                axios({
                method: 'post',
                url: `get-merchants-live-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                    this.getReport();
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getReport() {
            if(this.$store.state.user.id <= 3) {
                axios({
                method: 'post',
                url: `merchants-value-volume`,
                data: { merchant: typeof this.merchant !== 'undefined' ? this.merchant.name : null,
                        fromDate: this.fromDate,
                        toDate: this.toDate },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.report = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else {
                axios({
                method: 'post',
                url: `merchants-value-volume-client`,
                data: { merchant: Object.keys(this.merchant).length === 0 ? this.merchants : [this.merchant],
                        fromDate: this.fromDate,
                        toDate: this.toDate },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.report = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            
        },
        clearMerchant() {
            this.merchant = {};
            this.getReport();
        },
        handleDateFilters() {
            if(this.toDate < this.fromDate) {
                this.fromDate = this.toDate;
            }
            this.getReport();
        },
        download() {
            axios({
                method: 'post',
                url: 'download-merchants-value-volume',  
                data: { merchant: Object.keys(this.merchant).length === 0 ? this.merchants : [this.merchant],
                        fromDate: this.fromDate,
                        toDate: this.toDate },              
                responseType: 'blob',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'merchants-value-volume-report.csv');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(e => {
                    this.errors.push(e)
            })
        }
    }
}
</script>

<style>

</style>